export { flag } from "@/flags/flag";
export { useFlag, useFlags } from "@/flags/use-flag";
